'use strict';

module.exports = function average(key) {
  if (key === undefined) {
    return this.sum() / this.items.length;
  }

  return new this.constructor(this.items).pluck(key).sum() / this.items.length;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/average.js
// module id = 371
// module chunks = 2